import React, { useState } from 'react'
import { arrayOf, shape, string, func, bool } from 'prop-types'
import classnames from 'classnames'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'
import Markdown from 'components/atoms/MarkdownContent'
import FigureSvg from 'components/atoms/SVGIcons/Figure'
import TmvnCarousel from 'components/molecules/TmvnCarousel'


import { Modal, ModalBody, SVGIcon } from 'components/qstrap'

import SectionTitleWithIcon from 'components/molecules/SectionTitleWithIcon'

import Relazsizes from 'relazsizes'
import config from 'config'

const { assets_url: assetsUrl } = config

const FigureItem = ({ id, name, photo, description, onShowMore, extended }) => {
  const className = classnames('figure-item', {
    'figure-item--summarized': !extended,
  })
  return (
    <div id={`figure-${id}`} className={className}>
      <div className="figure-item__photo">
        <Relazsizes
          dataSrc={photo}
          className="figure-item__photo-img"
          alt={name}
        />
      </div>
      <div className="figure-item__detail">
        <Typography component="h4" variant="headline" className="figure-item__name">
          { name }
        </Typography>
        <div className="figure-item__content">
          <Markdown className="figure-item__content-text" content={description} />
          {
            !extended &&
            <a
              href="#"
              className="figure-item__show-more"
              onClick={(e) => {
                e.preventDefault()
                onShowMore()
              }}
            >
              Baca Selengkapnya...
            </a>
          }
        </div>
      </div>
      <style jsx>
        {`
          .figure-item {
            background-color: #fff;
            :global(&__photo-img) {
              width: 100%;
              height: 270px;
              object-fit: cover;
              object-position: center center;
              @media screen and (min-width: 768px) {
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
              }
            }
            &__detail {
              padding: 32px;
            }
            :global(&__name) {
              font-weight: bold;
            }
            :global(&__content-text) {
              margin: 16px 0;
            }
            &__show-more {
              display: block;
              font-size: 14px;
              font-weight: bold;
              color: #0fc3c4;
              text-align: center;
            }
            @media screen and (min-width: 768px) {
              border-radius: 8px;
            }
            &.figure-item--summarized {
              box-shadow: 0 4px 16px 0 rgba(107, 143, 188, 0.1);
              border: solid 1px #e3ecf5;
              border-radius: 8px;
              :global(.figure-item__content-text) {
                overflow: hidden;
                position: relative;
                line-height: 2em;
                /* height = line-height (2) * lines max number (4) + 1em extra space */
                height: 9em;
                text-align: justify;
              }
              :global(.figure-item__photo-img) {
                height: 240px;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
              }
              .figure-item__photo {
                margin: -1px;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

FigureItem.propTypes = {
  id: string,
  name: string,
  photo: string,
  description: string,
  onShowMore: func,
  extended: bool,
}

const CareerInspirationalFigures = ({ figures }) => {
  const [state, setState] = useState({
    showFigure: false,
    selectedFigure: {},
  })

  const showFigureDetail = (figure) => {
    setState({
      showFigure: true,
      selectedFigure: {
        ...figure,
      },
    })
  }

  const figureItems = figures.map((figure, idx) => (
    <FigureItem {...figure} onShowMore={() => showFigureDetail(figure)} key={`cd-ifsi-${idx}`}/>
  ))

  return (
    <div id="figures" className="career-inspirational-figures">
      <div className="career-inspirational-figures__bg"/>
      <SectionContainer
        paddingBottom={80}
        className="career-inspirational-figures__content"
        backgroundColor="transparent"
      >
        <Container>
          <div className="career-inspirational-figures__title">
            <FigureSvg fill="#0FC3C4" height="32px" width="32px" />
            <SectionTitleWithIcon title="Tokoh Inspiratif" />
            <div className="career-inspirational-figures__gallery">
              <Row>
                {
                  figureItems.map((figureItem, idx) => (
                    <Col
                      md={{
                        size: 6,
                        offset: figureItems.length === 1 && 3,
                      }}
                      key={`cif--${idx}`}
                    >
                      {figureItem}
                    </Col>
                  ))
                }
              </Row>
              <TmvnCarousel id="career-if-crsl" items={figureItems}/>
            </div>
          </div>
        </Container>
        {
          state.showFigure &&
          <Modal
            autoFocus={false}
            isOpen
            fade={false}
            toggle={() => setState({ showFigure: !state.showFigure })}
            className="career-inspirational-figures__modal-detail"
          >
            <ModalBody>
              <button
                id="close-modal"
                className="btn-close pull-right"
                type="button"
                onClick={() => setState({ showFigure: false })}
              >
                <SVGIcon name="common-close" size="md"/>
              </button>
              <FigureItem {...state.selectedFigure} extended />
            </ModalBody>
          </Modal>
        }
      </SectionContainer>
      <style jsx>
        {`
          .career-inspirational-figures {
            position: relative;
            overflow: hidden;
            &__title {
              display: flex;
              flex-direction: column;
              align-items: center;
              :global(svg) {
                margin-bottom: 16px;
              }
            }
            &__gallery {
              width: 100%;
              :global(.cmps-row) {
                @media screen and (max-width: 767px) {
                  display: none;
                }
              }
              :global(.tmvn-carousel) {
                @media screen and (min-width: 768px) {
                  display: none;
                }
              }
            }
            &__bg {
              background-color: #2440a4;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              transform: skewX(-80deg);
            }
            :global(&__content) {
              position: relative;
              background-image: url(${assetsUrl}/assets/img/major_detail/rectangle-element.svg), url(${assetsUrl}/assets/img/rect-yellow-accent.svg), url(${assetsUrl}/assets/img/major_detail/rectangle-element.svg);
              background-repeat: no-repeat, no-repeat;
              background-position-x: 90%, 10%, 0;
              background-position-y: 55%, 40%, 80%;
              background-size: auto, auto, 10%;
            }
            :global(&__modal-detail) {
              :global(.modal-content) {
                @media screen and (max-width: 767px) {
                  border: none;
                  border-radius: 0;
                  box-shadow: unset;
                }
              }
              :global(.modal-body) {
                padding: 0;
              }
              @media screen and (max-width: 767px) {
                margin: 0;
              }
              button.btn-close {
                background: transparent;
                border: none;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

const figureType = shape({
  id: string,
  name: string,
  photo: string,
  description: string,
})

CareerInspirationalFigures.propTypes = {
  figures: arrayOf(figureType),
}

export default CareerInspirationalFigures
